import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Inject, Input, OnChanges, PLATFORM_ID, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { take } from 'rxjs/operators';

@Component({
    selector: 'svg-loader',
    standalone: true,
    imports: [CommonModule, HttpClientModule],
    encapsulation: ViewEncapsulation.None,
    template: `
        <div  [style.fill]="fillColor"  class='csvg' #svgContainer></div>
        `
})
export class SVGLoaderComponent implements OnChanges, AfterViewInit {
    @Input() public SVGUrl = '';
    @Input() public fillColor;

    constructor(
        private httpClient: HttpClient,
        @Inject(PLATFORM_ID) private platformId: any
    ) { }

    ngAfterViewInit(): void {
        this.getSvg();
    }

    @ViewChild('svgContainer') svgContainer!: ElementRef;

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes.SVGUrl?.isFirstChange?.()) {
            this.getSvg();
        }
    }

    getSvg() {
        if (isPlatformBrowser(this.platformId)) {
            let headers = new HttpHeaders();
            headers = headers.set('svg', 'true');

            const requestOptions = {
                headers: headers,
                responseType: 'text' as any
            };

            this.httpClient.get(this.SVGUrl, requestOptions).pipe(take(1)).subscribe(svg => {
                this.svgContainer.nativeElement.innerHTML = `${svg}`;
            }, error => {
                this.svgContainer.nativeElement.innerHTML = '';
            });
        }
    }
}